module.exports = __webpack_public_path__ + "static/media/tickets.15d2d75d.svg";